import App from './App.svelte';
function loadWidget(id, widgetId, host) {
    let app = new App({
        target: document.getElementById(id) || document.body,
        props: { widgetId: widgetId, host: host }
    });
    return app;
}
export default loadWidget;
